import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrdersService } from 'src/app/core/orders.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-order-details-note-dialog',
  templateUrl: './order-details-note-dialog.component.html',
})
export class OrderDetailsNoteDialogComponent {
  note_form_group: FormGroup;
  is_saving_note: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<OrderDetailsNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { order_id?: string; store_id?: string; note?: string },
    form_builder: FormBuilder,
    private orders_service: OrdersService,
    private error_service: ErrorService,
  ) {
    this.note_form_group = form_builder.group({ note: [data?.note ?? ''] });
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onSaveClick(): void {
    if (!this.data.order_id || !this.data.store_id || this.is_saving_note) return;

    const note = this.note_form_group.get('note')?.value ?? '';
    this.is_saving_note = true;
    this.orders_service.setNote(this.data.store_id, this.data.order_id, note).subscribe({
      next: () => this.dialog_ref.close({ success: true, note }),
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
      },
    });
  }
}
